// Charge la base commune
import './common.js'

// Contact Form
async function getContactForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm", webpackPreload: true */ './js/components/contactForm.js').then(() => {
    $f.load(false)
    /* global Waypoint */
    Waypoint.refreshAll()
  })
}

// Sell Ground Form
async function getSellGroundForm ($f) {
  $f.load()
  import(/* webpackChunkName: "sellGroundForm", webpackPreload: true */ './js/components/sellGroundForm.js').then(() => {
    $f.load(false)
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion du formulaire de contact
  const $f = $('.contact-form')
  if ($f.length) {
    $f.waypoint(function () {
      getContactForm($f)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  const $s = $('.sell-ground-form')
  if ($s.length) {
    $s.waypoint(function () {
      getSellGroundForm($s)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  if ($('#go').length) {
    const t = $('#go')
    $('html, body').animate({
      scrollTop: ($(t).offset().top - $('#header').height() - 100)
    }, 300)
  }
})
